import { Handshake } from "lucide-react";

/**
 * Barra horizontal fina com marquee infinito dos parceiros.
 * Usa wordmarks tipográficos até chegarem os logos oficiais.
 * TODO (equipe): trocar por <img src="/uploads/partners/xxx.svg" /> quando
 * os arquivos forem enviados. O componente já suporta mistura de logos
 * e wordmarks sem mudanças no CSS.
 */
const PARTNERS = [
  { id: "karne", text: "Karne", accent: "& Keijo", tone: "ink", font: "serif" },
  { id: "vivo", text: "vivo", tone: "purple", font: "sans" },
  { id: "bomleite", text: "Bom Leite", tone: "blue", font: "sans" },
  { id: "vitarella", text: "Vitarella", tone: "red", font: "serif" },
  { id: "iquine", text: "IQUINE", tone: "orange", font: "sans" },
  { id: "uninassau", text: "UniNassau EAD", tone: "ink", font: "sans" },
  { id: "defensoria", text: "Defensoria Pública PE", tone: "ink", font: "serif" },
];

const TONE = {
  ink: "text-ga-ink/80",
  purple: "text-purple-600",
  blue: "text-blue-600",
  red: "text-red-600",
  orange: "text-orange-600",
};

function Item({ p }) {
  const fontClass = p.font === "serif" ? "font-display" : "font-sans";
  return (
    <div
      data-testid={`parceiro-ticker-${p.id}`}
      className="flex items-center gap-2 shrink-0"
    >
      <span className={`${fontClass} ${TONE[p.tone] || "text-ga-ink"} font-black text-xl sm:text-2xl tracking-tight leading-none whitespace-nowrap`}>
        {p.text}
      </span>
      {p.accent && (
        <span className="text-ga-ink/50 font-semibold text-sm sm:text-base whitespace-nowrap">
          {p.accent}
        </span>
      )}
    </div>
  );
}

export default function PartnersMarquee() {
  // Duplica a lista para criar loop infinito suave
  const loop = [...PARTNERS, ...PARTNERS];

  return (
    <section
      data-testid="partners-marquee"
      aria-label="Parceiros do Instituto"
      className="relative bg-white border-y border-border overflow-hidden"
    >
      <div className="container-ga py-6 sm:py-7">
        <div className="flex items-center gap-8">
          <div className="hidden md:flex items-center gap-2 shrink-0 pr-6 border-r border-border">
            <Handshake className="w-4 h-4 text-ga-emerald" />
            <span className="text-[10px] uppercase tracking-[0.22em] font-bold text-ga-ink/55 whitespace-nowrap">
              Em parceria com
            </span>
          </div>

          {/* Marquee track */}
          <div className="relative flex-1 min-w-0 overflow-hidden mask-x-fade">
            <div
              className="flex gap-10 sm:gap-14 animate-marquee"
              style={{ width: "max-content" }}
              data-testid="partners-marquee-track"
            >
              {loop.map((p, i) => (
                <Item key={`${p.id}-${i}`} p={p} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
